var map = {
	"./boitekanelo.json": [
		2022,
		22
	],
	"./config.json": [
		8607,
		607
	],
	"./default.json": [
		9026
	],
	"./ngip.json": [
		4579,
		579
	],
	"./rsmbotswana.json": [
		3902,
		902
	],
	"./sigstatus.json": [
		1260,
		260
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3744;
module.exports = webpackAsyncContext;